import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PublicHoliday } from '../../types/team.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { CreatePublicHolidayDto } from './use-create-public-holiday';

export type UpdatePublicHolidayDto = Partial<CreatePublicHolidayDto>;

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useUpdatePublicHoliday = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateHoliday, isPending } = useAppMutation(
    [QueryKey.UPDATE_PUBLIC_HOLIDAY],
    {
      mutationFn: ({ id, ...body }: { id: string } & UpdatePublicHolidayDto) =>
        ApiService.patch<PublicHoliday, UpdatePublicHolidayDto>(
          { endpoint: BackendRoute.TEAM_PUBLIC_HOLIDAYS, routePath: [id] },
          { body },
        ),
      onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PUBLIC_HOLIDAYS] }),
    },
  );

  return { updateHoliday, isPending };
};
